export const errorEndpoint = {
	maintenance: "/maintenance",
	notStarted: "/not-started",
	close: "/close",
	invalid: "/invalid",
	answered: "/answered",
} as const;

export const endpoint = {
	enquete: "/enquete",
	images: "/upload-images",
	start: "/start",
	question: "/question",
	preview: "/preview",
	finish: "/finish",
	quota: "/quota",
	rawdata: "/rawdata",
	...errorEndpoint,
} as const;

export type EndpointKey = keyof typeof endpoint;
export type Endpoint = typeof endpoint[EndpointKey];

export type ErrorEndpointKey = keyof typeof errorEndpoint;
export type ErrorEndpoint = typeof errorEndpoint[ErrorEndpointKey];
